import { render } from "./App.vue?vue&type=template&id=5c3e1546"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5c3e1546&lang=css"
script.render = render

export default script